module.exports = __webpack_public_path__ + "static/img/sign_su.1affcd16.png";